<template>
  <!-- Componente invisibile che ascolta MQTT per i cambi permessi -->
  <div></div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import MessageManager from "@/domain/core/utils/messageManager"
import mqttTopics from "@/domain/core/constant/mqttTopics"

export default {
  name: 'PermissionListener',
  
  computed: {
    ...mapGetters('login', ['user']),
  },
  
  mounted() {
    this.setupListener()
  },
  
  beforeDestroy() {
    MessageManager.off('permission-listener-user')
    MessageManager.off('permission-listener-all')
  },
  
  methods: {
    ...mapActions('login', ['refreshPermissions']),
    ...mapActions('eventBus', ['emitEvent']),
    
    setupListener() {
      // Ascolta i cambi permessi per l'utente corrente specifico
      // L'userId viene già gestito automaticamente da MessageManager quando l'utente fa login
      MessageManager.on(mqttTopics.user.permissions, async (data) => {
        await this.handlePermissionChange()
      }, 'permission-listener-user')
      
      // Ascolta i cambi permessi broadcast per TUTTI gli utenti
      MessageManager.on(mqttTopics.user.permissionsAll, async (data) => {
        await this.handlePermissionChange()
      }, 'permission-listener-all')
    },
    
    async handlePermissionChange() {
      // Refresh permissions in store
      await this.refreshPermissions()
      
      // Emit event on eventBus for components to react
      await this.emitEvent({
        event: 'user-permissions-changed',
        payload: { timestamp: Date.now() }
      })
    }
  }
}
</script>